import type { Types } from 'mongoose';

// Deduplicate an array
const unique = <T,>(input: T[]) => [...Array.from(new Set(input))];

export const uniqueObjectIds = (input: Types.ObjectId[]) => {
  const result = [];
  const set = new Set();
  for (const id of input) {
    if (set.has(id.toString())) {
      continue;
    }
    set.add(id.toString());
    result.push(id);
  }
  return result;
};

export default unique;
